import styled from 'styled-components';

export const Image = styled.img`
  position: absolute;
  top: 20px;
  right: 26.5px;
  &:hover {
    cursor: pointer;
  }
  transition: all 1s;
`;
